<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入企业名称" prefix-icon="el-icon-search"
                              clearable
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                    <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button>
                </div>
                <div>
                    <!-- <el-upload
                            :show-file-list="false"
                            :before-upload="beforeUpload"
                            :on-success="onSuccess"
                            :on-error="onError"
                            :disabled="importDataDisabled"
                            style="display: inline-flex;margin-right: 8px"
                            action="/employee/basic/import">
                        <el-button :disabled="importDataDisabled" type="success" :icon="importDataBtnIcon">
                            {{importDataBtnText}}
                        </el-button>
                    </el-upload> -->
                    <el-button type="primary" @click=" " icon="el-icon-edit-outline">
                        修改联系人
                    </el-button>
                    <el-button type="primary" icon="el-icon-edit-outline" @click=" ">
                        修改邮箱
                    </el-button>
                    <el-button type="primary" @click="showAddIntershipView" icon="el-icon-plus">
                        新建信息
                    </el-button>
                </div>
            </div>
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">

                     <el-row>
                        <el-col :span="6">
                            职位名称:
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="searchValue.jobName"
                                          placeholder="请输入职位名称"></el-input>
                        </el-col>
                        <el-col :span="6">
                            公司名称:
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="searchValue.companyName"
                                          placeholder="请输入公司名称"></el-input>
                        </el-col>
                        <el-col :span="6">
                           学历要求:
                                <el-select v-model="searchValue.minEducation" clearable="" placeholder="请选择学历要求" size="mini" style="width: 150px;">
                                    <el-option
                                            v-for="item in platList"
                                            :key="item.dictValue"
                                            :label="item.dictValue"
                                            :value="item.dictValue">
                                    </el-option>
                                </el-select>
                           
                        </el-col>
                        <el-col :span="6">
                            工作地点:
                                <el-select  v-model="provinceId" clearable="" placeholder="省份" size="mini" @change="changeProvince" style="width: 80px;">
                                    <el-option
                                            v-for="item in provinceList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                <el-select :disabled="cityView" v-model="selectedCity"  placeholder="城市" size="mini" @change="selectCity" style="width: 80px;">
                                    <el-option
                                            v-for="item in cityList"
                                            :key="item.name"
                                            :label="item.name"
                                            :value="item.name">
                                    </el-option>
                                </el-select>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            最低薪资:
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="searchValue.salaryMin"
                                          placeholder="请输入最低薪资"></el-input>
                        </el-col>
                        <el-col :span="6">
                            最高薪资:
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="searchValue.salaryMax"
                                          placeholder="请输入最高薪资"></el-input>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="4">
                            包食宿:
                                <el-select v-model="searchValue.eatRoom" clearable="" placeholder="请选择" size="mini" style="width: 80px;">
                                    <el-option
                                            v-for="item in eatRoomList"
                                            :key="item.dictId"
                                            :label="item.dictValue"
                                            :value="item.dictId">
                                    </el-option>
                                </el-select>
                        </el-col>
                        <el-col :span="5">
                            开始日期:
                                <el-date-picker
                                        v-model="searchValue.upTime"
                                        size="mini"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        style="width: 150px;"
                                        placeholder="开始日期">
                                </el-date-picker>
                        </el-col>
                        <el-col :span="5">
                            截止时间:
                                <el-date-picker
                                        v-model="searchValue.downTime"
                                        size="mini"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        style="width: 150px;"
                                        placeholder="截止时间">
                                </el-date-picker>
                        </el-col>
                        <el-col :span="5" :offset="4">
                            <el-button size="mini">取消</el-button>
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="initEmps('advanced')">搜索</el-button>
                        </el-col>
                    </el-row>
                    
                </div>
            </transition>
        </div>
        <!-- 标题列 --->
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    ref="projectTable"
                    style="width: 100%"
                    :row-key="row=>row.jobId"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{'text-align':'center'}">
                   
                    <!-- <el-table-column
                        type="selection" :reserve-selection="true"
                        width="55">
                    </el-table-column> -->
                    <el-table-column
                            fixed
                            align="left"
                            label="公司名称"
                            width="180">
                            <template slot-scope="scope">
                                <span class="companyTop"> <i  v-if="scope.row.beTop" class="beTop"></i><span >{{scope.row.companyName}}</span></span>
                                
                            </template>

                    </el-table-column>
                    <el-table-column
                            prop="minEducation"
                            align="center"
                            label="学历要求"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="salary"
                            align="center"
                            label="薪资"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="workCity"
                            align="center"
                            label="工作地点"
                            width="130">
                    </el-table-column>
                    <el-table-column
                            prop="salaryMin"
                            align="center"
                            label="最低薪资"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="salaryMax"
                            align="center"
                            label="最高薪资"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="jobNeedNum"
                            align="center"
                            label="待招人数"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="包吃住"
                            width="80">
                            <template slot-scope="scope">
                                <span v-if="scope.row.eatRoom">是</span>
                                <span v-else>否</span>
                            </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="时薪"
                            width="100">
                            <template slot-scope="scope">
                                <span v-if="scope.row.hourEducation">{{scope.row.hourEducation}}</span>
                                <span v-else>/</span>
                            </template>
                    </el-table-column>
                    <el-table-column
                            prop="upTime"
                            align="center"
                            label="开始时间"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="downTime"
                            align="center"
                            label="截止日期"
                            width="180">
                    </el-table-column>

                    <el-table-column
                            align="center"
                            label="工作明细数量"
                            width="180">
                            <template  slot-scope="scope">
                                <!-- <span v-if="scope.row.jobNumber==0">{{scope.row.jobNumber}}</span> -->
                                <span  @click="showDetail(scope.row)" style="color: blue;">{{scope.row.jobNumber}}</span>
                            </template>
                    </el-table-column>
                    <el-table-column
                            prop="jobDesc"
                            align="center"
                            label="职位描述"
                            width="180">
                    </el-table-column>

                    <el-table-column
                            prop="specialDesc"
                            align="left"
                            label="特殊描述"
                            :show-overflow-tooltip="true"
                            width="180">
                    </el-table-column>
                <el-table-column
                        fixed="right"
                        align="center"
                        width="240"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="beTop(scope.row)" style="padding: 3px" size="mini" type="primary">{{scope.row.beTop?'取消置顶':'置顶'}}</el-button>
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
       

        <!-- 新增和编辑 --->
        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
                width="80%">
            <div>
                <el-form :model="emp" :rules="rules" ref="empForm">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="职位名称:" prop="jobName">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.jobName"
                                          placeholder="请输入职位名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="公司名称:" prop="companyName">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.companyName"
                                          placeholder="请输入公司名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="学历要求:" prop="minEducation">
                                <el-select v-model="emp.minEducation" clearable="" placeholder="请选择学历要求" size="mini" style="width: 150px;">
                                    <el-option
                                            v-for="item in platList"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item  label="工作地点:" prop="workCity">
                                <el-select  v-model="provinceId" clearable="" placeholder="省份" size="mini" @change="changeProvince" style="width: 80px;">
                                    <el-option
                                            v-for="item in provinceList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                <el-select :disabled="cityView" v-model="selectedCity"  placeholder="城市" size="mini" @change="selectCity" style="width: 80px;">
                                    <el-option
                                            v-for="item in cityList"
                                            :key="item.name"
                                            :label="item.name"
                                            :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="最低薪资:" prop="salaryMin">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.salaryMin"
                                          placeholder="请输入最低薪资"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="最高薪资:" prop="salaryMax">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.salaryMax"
                                          placeholder="请输入最高薪资"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="需求人数:" prop="jobNeedNum">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.jobNeedNum"
                                          placeholder="请输入需求人数"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="时薪:" prop="hourEducation">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.hourEducation"
                                          placeholder="请输入时薪"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="4">
                            <el-form-item label="包食宿:" prop="eatRoom">
                                <el-select v-model="emp.eatRoom" clearable="" placeholder="请选择" size="mini" style="width: 80px;">
                                    <el-option
                                            v-for="item in eatRoomList"
                                            :key="item.dictId"
                                            :label="item.dictValue"
                                            :value="item.dictId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="开始日期:" prop="upTime">
                                <el-date-picker
                                        v-model="emp.upTime"
                                        size="mini"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        style="width: 150px;"
                                        placeholder="开始日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="截止时间:" prop="downTime">
                                <el-date-picker
                                        v-model="emp.downTime"
                                        size="mini"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        style="width: 150px;"
                                        placeholder="截止时间">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="备注:" prop="specialDesc">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.specialDesc"
                                          placeholder="请输入备注"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="doAddEmp">确 定</el-button>
        </span>
        </el-dialog>

        <!-- 岗位明细 --->
        <el-dialog
                :title="title"
                :visible.sync="detailDisplay"
                width="38%">
            <div>
                <el-table
                    :data="details"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    ref="detailTable"
                    style="width: auto"
                    :row-key="row=>row.id"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{'text-align':'center'}">
                   
                    <!-- <el-table-column
                        type="selection" :reserve-selection="true"
                        width="55">
                    </el-table-column> -->
                    <el-table-column
                           
                            align="center"
                            label="职位"
                            width="180">
                            <template slot-scope="scope">
                                <span > {{scope.row.name}}</span>
                                
                            </template>

                    </el-table-column>
                    <el-table-column
                            prop="salary"
                            align="center"
                            label="薪资"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="性别要求"
                            width="120">
                            <template slot-scope="scope">
                                <span v-if="scope.row.sexNeed==0">男</span>
                                <span v-else-if="scope.row.sexNeed==1">女</span>
                                <span v-else >不限</span>
                            </template>
                    </el-table-column>
                    <el-table-column
                            prop="jobNeedNum"
                            align="center"
                            label="招聘人数"
                            width="120">
                    </el-table-column>
                    <el-table-column
                        
                        align="center"
                        width="110"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditDetailView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="deleteDetail(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>
                    </template>
                </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="openAddDetail">添 加</el-button>
                <el-button @click="detailDisplay = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 岗位明细 --->
        <el-dialog
                :title="titleDetail"
                :visible.sync="showAddDetail"
                width="35%">
            <div>
                <el-form :model="detail" :rules="detailRules" ref="detailForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="职位名称:" prop="name">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="detail.name"
                                          placeholder="请输入职位名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="薪资:" prop="salary">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="detail.salary"
                                          placeholder="请输入公司名称"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="性别要求:" prop="sexNeed">
                                <el-select v-model="detail.sexNeed" clearable="" placeholder="请选择性别要求" size="mini" style="width: 150px;">
                                    <el-option
                                            v-for="item in sexDic"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="招聘人数:" prop="jobNeedNum">
                                <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="detail.jobNeedNum"
                                          placeholder="请输入招聘人数"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDetail">确 认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "projectInfo",
        data() {
            return {
                // 岗位明细岗位参数
                detailDisplay:false,
                details:[],
                showAddDetail: false,
                detail:{},
                titleDetail: '',
                jobId: '', 
                sexDic:[
                    {
                        dictValue: 0,
                        dictLabel: '男'
                    },{
                        dictValue: 1,
                        dictLabel: '女'
                    },{
                        dictValue: 2,
                        dictLabel: '不限'
                    }
                ],
                searchValue: {
                    politicId: null,
                    nationId: null,
                    jobLevelId: null,
                    posId: null,
                    engageForm: null,
                    departmentId: null,
                    beginDateScope: null
                },
                typeList: [{
                    dictValue: '01',
                    dictLabel: '微信'
                    }, {
                    dictValue: '02',
                    dictLabel: 'QQ'
                    }, {
                    dictValue: '03',
                    dictLabel: '公众号'
                }],
                provinceId: null,
                selectedCity: null,
                cityList:[],
                cityView: true,
                provinceList: [{"name":"北京","id":1,"tid":"bj"},{"name":"上海","id":2,"tid":"sh"},{"name":"广东","id":4,"tid":"gd"},{"name":"江苏","id":19,"tid":"js"},{"name":"天津","id":3,"tid":"tj"},{"name":"福建","id":5,"tid":"macao"},{"name":"海南","id":8,"tid":"hainan"},{"name":"安徽","id":9,"tid":"ah"},{"name":"贵州","id":10,"tid":"gz"},{"name":"甘肃","id":11,"tid":"gs"},{"name":"广西","id":12,"tid":"gx"},{"name":"河北","id":13,"tid":"hebei"},{"name":"河南","id":14,"tid":"henan"},{"name":"黑龙江","id":15,"tid":"hlj"},{"name":"湖北","id":16,"tid":"hubei"},{"name":"湖南","id":17,"tid":"hunan"},{"name":"吉林","id":18,"tid":"jl"},{"name":"江西","id":20,"tid":"jx"},{"name":"辽宁","id":21,"tid":"ln"},{"name":"内蒙古","id":22,"tid":"nmg"},{"name":"宁夏","id":23,"tid":"nx"},{"name":"青海","id":24,"tid":"qh"},{"name":"山东","id":25,"tid":"sd"},{"name":"山西","id":26,"tid":"sx"},{"name":"陕西","id":27,"tid":"sx2"},{"name":"四川","id":28,"tid":"si"},{"name":"西藏","id":29,"tid":"xz"},{"name":"新疆","id":30,"tid":"xj"},{"name":"云南","id":31,"tid":"yn"},{"name":"浙江","id":32,"tid":"zj"},{"name":"重庆","id":33,"tid":"cq"},{"name":"香港","id":34,"tid":"hk"},{"name":"台湾","id":35,"tid":"tw"},{"name":"澳门","id":36,"tid":"macao"},{"name":"国外及其他","id":37,"tid":"haiwai"}],
                cityLists: [{"pid":15,"city":[{"name":"大兴安岭","id":321},{"name":"大庆","id":320},{"name":"哈尔滨","id":322},{"name":"鹤岗","id":323},{"name":"黑河","id":324},{"name":"鸡西","id":325},{"name":"佳木斯","id":326},{"name":"牡丹江","id":327},{"name":"七台河","id":328},{"name":"齐齐哈尔","id":329},{"name":"双鸭山","id":330},{"name":"绥化","id":331},{"name":"伊春","id":332}]},{"pid":30,"city":[{"name":"阿克苏","id":136},{"name":"阿勒泰","id":423},{"name":"阿拉尔","id":137},{"name":"巴音郭楞蒙古自治州","id":138},{"name":"博乐","id":419},{"name":"博尔塔拉蒙古自治州","id":139},{"name":"昌吉回族自治州","id":140},{"name":"哈密","id":141},{"name":"和田","id":142},{"name":"喀什","id":143},{"name":"克孜勒苏柯尔克孜自治州","id":151},{"name":"克拉玛依","id":144},{"name":"库尔勒","id":425},{"name":"奎屯","id":418},{"name":"石河子","id":145},{"name":"塔城","id":428},{"name":"图木舒克","id":146},{"name":"吐鲁番","id":147},{"name":"乌鲁木齐","id":148},{"name":"五家渠","id":149},{"name":"伊犁哈萨克自治州","id":150}]},{"pid":8,"city":[{"name":"白沙黎族自治县","id":71},{"name":"保亭黎族苗族自治县","id":87},{"name":"昌江黎族自治县","id":72},{"name":"澄迈县","id":73},{"name":"儋州","id":86},{"name":"定安县","id":74},{"name":"东方","id":75},{"name":"海口","id":76},{"name":"乐东黎族自治县","id":77},{"name":"临高县","id":78},{"name":"陵水黎族自治县","id":79},{"name":"琼中黎族苗族自治县","id":88},{"name":"琼海","id":80},{"name":"三亚","id":81},{"name":"屯昌县","id":82},{"name":"万宁","id":83},{"name":"文昌","id":84},{"name":"五指山","id":85},{"name":"三沙","id":458}]},{"pid":23,"city":[{"name":"固原","id":238},{"name":"石嘴山","id":239},{"name":"吴忠","id":240},{"name":"银川","id":241},{"name":"中卫","id":417}]},{"pid":16,"city":[{"name":"鄂州","id":303},{"name":"恩施土家族苗族自治州","id":304},{"name":"黄冈","id":305},{"name":"黄石","id":306},{"name":"江汉市","id":448},{"name":"荆州","id":308},{"name":"荆门","id":307},{"name":"潜江","id":309},{"name":"神农架林区","id":310},{"name":"十堰","id":311},{"name":"随州","id":312},{"name":"天门","id":313},{"name":"武汉","id":314},{"name":"仙桃","id":315},{"name":"咸宁","id":316},{"name":"襄樊","id":317},{"name":"孝感","id":318},{"name":"宜昌","id":319}]},{"pid":31,"city":[{"name":"保山","id":120},{"name":"楚雄彝族自治州","id":121},{"name":"大理白族自治州","id":122},{"name":"德宏傣族景颇族自治州","id":123},{"name":"迪庆藏族自治州","id":124},{"name":"红河哈尼族彝族自治州","id":125},{"name":"昆明","id":126},{"name":"丽江","id":127},{"name":"临沧","id":128},{"name":"怒江傈傈族自治州","id":129},{"name":"曲靖","id":130},{"name":"思茅","id":131},{"name":"文山壮族苗族自治州","id":132},{"name":"西双版纳傣族自治州","id":133},{"name":"玉溪","id":134},{"name":"昭通","id":135}]},{"pid":35,"city":[{"name":"台湾","id":108}]},{"pid":22,"city":[{"name":"阿拉善盟","id":226},{"name":"巴彦浩特","id":420},{"name":"巴彦淖尔盟","id":227},{"name":"包头","id":228},{"name":"赤峰","id":229},{"name":"鄂尔多斯","id":230},{"name":"海拉尔","id":450},{"name":"呼伦贝尔","id":232},{"name":"呼和浩特","id":231},{"name":"集宁市","id":424},{"name":"临河市","id":451},{"name":"通辽","id":233},{"name":"乌兰察布","id":235},{"name":"乌兰浩特","id":452},{"name":"乌海","id":234},{"name":"锡林浩特","id":427},{"name":"锡林郭勒盟","id":236},{"name":"兴安盟","id":237}]},{"pid":34,"city":[{"name":"香港","id":107}]},{"pid":32,"city":[{"name":"杭州","id":109},{"name":"湖州","id":110},{"name":"嘉兴","id":111},{"name":"金华","id":112},{"name":"丽水","id":113},{"name":"宁波","id":114},{"name":"衢州","id":119},{"name":"绍兴","id":115},{"name":"台州","id":116},{"name":"温州","id":117},{"name":"舟山","id":118}]},{"pid":9,"city":[{"name":"安庆","id":89},{"name":"蚌埠","id":90},{"name":"亳州","id":105},{"name":"巢湖","id":91},{"name":"池州","id":92},{"name":"滁州","id":93},{"name":"阜阳","id":94},{"name":"合肥","id":95},{"name":"淮北","id":96},{"name":"淮南","id":97},{"name":"黄山","id":98},{"name":"六安","id":99},{"name":"马鞍山","id":100},{"name":"宿州","id":101},{"name":"铜陵","id":102},{"name":"芜湖","id":103},{"name":"宣城","id":104}]},{"pid":21,"city":[{"name":"鞍山","id":242},{"name":"本溪","id":243},{"name":"朝阳","id":244},{"name":"大连","id":245},{"name":"丹东","id":246},{"name":"抚顺","id":247},{"name":"阜新","id":248},{"name":"葫芦岛","id":249},{"name":"锦州","id":250},{"name":"辽阳","id":251},{"name":"盘锦","id":252},{"name":"沈阳","id":253},{"name":"铁岭","id":254},{"name":"营口","id":255}]},{"pid":33,"city":[{"name":"重庆","id":106}]},{"pid":1,"city":[{"name":"北京","id":38}]},{"pid":480,"city":[{"name":"日本","id":481}]},{"pid":29,"city":[{"name":"阿里","id":152},{"name":"昌都","id":153},{"name":"拉萨","id":154},{"name":"林芝","id":155},{"name":"那曲","id":156},{"name":"日喀则","id":157},{"name":"山南","id":158}]},{"pid":14,"city":[{"name":"安阳","id":333},{"name":"鹤壁","id":334},{"name":"潢川市","id":415},{"name":"济源","id":335},{"name":"焦作","id":336},{"name":"开封","id":337},{"name":"洛阳","id":338},{"name":"漯河","id":349},{"name":"南阳","id":339},{"name":"平顶山","id":340},{"name":"濮阳","id":350},{"name":"三门峡","id":341},{"name":"商丘","id":342},{"name":"新乡","id":343},{"name":"信阳","id":344},{"name":"许昌","id":345},{"name":"郑州","id":346},{"name":"周口","id":347},{"name":"驻马店","id":348}]},{"pid":24,"city":[{"name":"德令哈","id":456},{"name":"格尔木","id":421},{"name":"共和","id":455},{"name":"果洛藏族自治州","id":218},{"name":"海东","id":220},{"name":"海北藏族自治州","id":219},{"name":"海南藏族自治州","id":221},{"name":"海晏","id":454},{"name":"海西蒙古族藏族自治州","id":222},{"name":"黄南藏族自治州","id":223},{"name":"西宁","id":224},{"name":"玉树藏族自治州","id":225}]},{"pid":4,"city":[{"name":"广州","id":41},{"name":"深圳","id":42},{"name":"东莞","id":47},{"name":"佛山","id":48},{"name":"潮州","id":46},{"name":"河源","id":49},{"name":"惠州","id":50},{"name":"江门","id":51},{"name":"揭阳","id":52},{"name":"茂名","id":53},{"name":"梅州","id":54},{"name":"清远","id":55},{"name":"汕头","id":56},{"name":"汕尾","id":57},{"name":"韶关","id":58},{"name":"阳江","id":59},{"name":"云浮","id":60},{"name":"湛江","id":61},{"name":"肇庆","id":62},{"name":"中山","id":63},{"name":"珠海","id":45}]},{"pid":36,"city":[{"name":"澳门","id":399}]},{"pid":19,"city":[{"name":"苏州","id":272},{"name":"常州","id":267},{"name":"淮安","id":268},{"name":"姜堰","id":405},{"name":"江阴","id":401},{"name":"靖江","id":402},{"name":"连云港","id":269},{"name":"南京","id":270},{"name":"南通","id":271},{"name":"宿迁","id":273},{"name":"泰兴","id":404},{"name":"泰州","id":274},{"name":"无锡","id":275},{"name":"兴化","id":403},{"name":"徐州","id":276},{"name":"盐城","id":277},{"name":"扬州","id":278},{"name":"镇江","id":279}]},{"pid":26,"city":[{"name":"大同","id":191},{"name":"晋中","id":193},{"name":"晋城","id":192},{"name":"临汾","id":194},{"name":"吕梁","id":195},{"name":"朔州","id":196},{"name":"太原","id":197},{"name":"忻州","id":198},{"name":"阳泉","id":199},{"name":"运城","id":200},{"name":"长治","id":190}]},{"pid":11,"city":[{"name":"白银","id":376},{"name":"定西","id":377},{"name":"甘南藏族自治州","id":378},{"name":"嘉峪关","id":379},{"name":"金昌","id":380},{"name":"酒泉","id":381},{"name":"兰州","id":382},{"name":"临夏回族自治州","id":383},{"name":"陇南","id":384},{"name":"平凉","id":385},{"name":"庆阳","id":386},{"name":"天水","id":387},{"name":"武威","id":388},{"name":"张掖","id":389}]},{"pid":18,"city":[{"name":"白城","id":294},{"name":"白山","id":295},{"name":"珲春市","id":411},{"name":"吉林","id":297},{"name":"辽源","id":298},{"name":"梅河口","id":449},{"name":"四平","id":299},{"name":"松原","id":300},{"name":"通化","id":301},{"name":"延吉市","id":422},{"name":"延边朝鲜族自治州","id":302},{"name":"长春","id":296}]},{"pid":3,"city":[{"name":"天津","id":40}]},{"pid":12,"city":[{"name":"百色","id":362},{"name":"北海","id":363},{"name":"崇左","id":364},{"name":"防城港","id":365},{"name":"桂林","id":366},{"name":"贵港","id":367},{"name":"河池","id":368},{"name":"贺州","id":369},{"name":"来宾","id":370},{"name":"柳州","id":371},{"name":"南宁","id":372},{"name":"钦州","id":373},{"name":"梧州","id":374},{"name":"玉林","id":375}]},{"pid":27,"city":[{"name":"安康","id":180},{"name":"宝鸡","id":181},{"name":"汉中","id":182},{"name":"商洛","id":183},{"name":"铜川","id":184},{"name":"渭南","id":185},{"name":"西安","id":186},{"name":"咸阳","id":187},{"name":"延安","id":188},{"name":"榆林","id":189}]},{"pid":17,"city":[{"name":"常德","id":280},{"name":"郴州","id":282},{"name":"衡阳","id":283},{"name":"怀化","id":284},{"name":"吉首市","id":416},{"name":"娄底","id":285},{"name":"邵阳","id":286},{"name":"湘潭","id":287},{"name":"湘西土家族苗族自治州","id":288},{"name":"益阳","id":289},{"name":"永州","id":290},{"name":"岳阳","id":291},{"name":"张家界","id":293},{"name":"长沙","id":281},{"name":"株洲","id":292}]},{"pid":2,"city":[{"name":"上海","id":39}]},{"pid":13,"city":[{"name":"保定","id":351},{"name":"沧州","id":352},{"name":"承德","id":353},{"name":"邯郸","id":354},{"name":"衡水","id":355},{"name":"廊坊","id":356},{"name":"秦皇岛","id":357},{"name":"石家庄","id":358},{"name":"唐山","id":359},{"name":"邢台","id":360},{"name":"张家口","id":361}]},{"pid":28,"city":[{"name":"阿坝藏族羌族自治州","id":159},{"name":"巴中","id":160},{"name":"成都","id":161},{"name":"达州","id":162},{"name":"德阳","id":163},{"name":"甘孜藏族自治州","id":164},{"name":"广元","id":166},{"name":"广安","id":165},{"name":"乐山","id":167},{"name":"凉山彝族自治州","id":168},{"name":"泸州","id":179},{"name":"眉山","id":169},{"name":"绵阳","id":170},{"name":"南充","id":171},{"name":"内江","id":172},{"name":"攀枝花","id":173},{"name":"遂宁","id":174},{"name":"西昌市","id":453},{"name":"雅安","id":175},{"name":"宜宾","id":176},{"name":"资阳","id":177},{"name":"自贡","id":178}]},{"pid":20,"city":[{"name":"抚州","id":256},{"name":"赣州","id":257},{"name":"吉安","id":258},{"name":"景德镇","id":259},{"name":"九江","id":260},{"name":"南昌","id":261},{"name":"萍乡","id":262},{"name":"上饶","id":263},{"name":"新余","id":264},{"name":"宜春","id":265},{"name":"鹰潭","id":266}]},{"pid":37,"city":[{"name":"其他国家和地区","id":400},{"name":"韩国","id":457},{"name":"马来西亚","id":408},{"name":"日本","id":480},{"name":"新加坡","id":407},{"name":"印度尼西亚","id":409}]},{"pid":25,"city":[{"name":"滨州","id":201},{"name":"德州","id":202},{"name":"东营","id":203},{"name":"菏泽","id":204},{"name":"济南","id":205},{"name":"济宁","id":206},{"name":"莱芜","id":207},{"name":"聊城","id":208},{"name":"临沂","id":209},{"name":"青岛","id":210},{"name":"日照","id":211},{"name":"泰安","id":212},{"name":"威海","id":213},{"name":"潍坊","id":214},{"name":"烟台","id":215},{"name":"枣庄","id":216},{"name":"淄博","id":217}]},{"pid":10,"city":[{"name":"安顺","id":390},{"name":"毕节","id":391},{"name":"都匀市","id":414},{"name":"贵阳","id":392},{"name":"凯里市","id":412},{"name":"六盘水","id":393},{"name":"黔东南苗族侗族自治州","id":394},{"name":"黔南布依族苗族自治州","id":395},{"name":"黔西南布依族苗族自治州","id":396},{"name":"铜仁","id":397},{"name":"兴义市","id":413},{"name":"遵义","id":398}]},{"pid":5,"city":[{"name":"福州","id":44},{"name":"龙岩","id":64},{"name":"南平","id":65},{"name":"宁德","id":66},{"name":"莆田","id":67},{"name":"泉州","id":68},{"name":"三明","id":69},{"name":"厦门","id":43},{"name":"漳州","id":70}]}],
                workCity:[
                    {
                        dictValue: '大专',
                        dictLabel: '大专及以上'
                    }

                ],
                platList: [{
                    dictValue: '大专',
                    dictLabel: '大专及以上'
                    }, {
                    dictValue: '本科',
                    dictLabel: '本科及以上'
                    }, {
                    dictValue: '硕士',
                    dictLabel: '硕士及以上'
                    }, {
                    dictValue: '初中',
                    dictLabel: '初中及以上'
                }],
                eatRoomList:[
                    { 
                        dictId:0,
                        dictValue:'否'
                    },{ 
                        dictId:1,
                        dictValue:'是'
                    }
                ],
                sourceList: [
                    {
                        dictValue: '01',
                        dictLabel: '自然流量'
                    }, 
                    {
                        dictValue: '02',
                        dictLabel: '销售引入'
                    }
                ],
                title: '',
                importDataBtnText: '导入数据',
                importDataBtnIcon: 'el-icon-upload2',
                importDataDisabled: false,
                showAdvanceSearchView: false,
                allDeps: [],
                upFilePlat:'',
                addFileTitleName: "上传文件窗口",
                addFileName: "",
                addArr: [],
                emps: [],
                loading: false,
                popVisible: false,
                popVisible2: false,
                dialogVisible: false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
                nations: [],
                joblevels: [],
                politicsstatus: [],
                positions: [],
                tiptopDegrees: ['大专', '本科', '硕士', '博士', '高中', '初中', '小学', '其他'],
                options: [{
                    value: '选项1',
                    label: '黄金糕'
                }, {
                    value: '选项2',
                    label: '双皮奶'
                }],
                inputDepName: '所属部门',
                emp: {
                    name: "javaboy",
                    gender: "男",
                    birthday: "1989-12-31",
                    idCard: "610122199001011256",
                    wedlock: "已婚",
                    nationId: 1,
                    nativePlace: "陕西",
                    politicId: 13,
                    email: "laowang@qq.com",
                    phone: "18565558897",
                    address: "深圳市南山区",
                    departmentId: null,
                    jobLevelId: 9,
                    posId: 29,
                    engageForm: "劳务合同",
                    tiptopDegree: "本科",
                    specialty: "信息管理与信息系统",
                    school: "深圳大学",
                    beginDate: "2017-12-31",
                    workState: "在职",
                    workID: "00000057",
                    contractTerm: 2,
                    conversionTime: "2018-03-31",
                    notworkDate: null,
                    beginContract: "2017-12-31",
                    endContract: "2019-12-31",
                    workAge: null
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    name: [{required: true, message: '请输入用户名', trigger: 'blur'}],
                    gender: [{required: true, message: '请输入性别', trigger: 'blur'}],
                    birthday: [{required: true, message: '请输入出生日期', trigger: 'blur'}],
                    idCard: [{required: true, message: '请输入身份证号码', trigger: 'blur'}, {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '身份证号码格式不正确',
                        trigger: 'blur'
                    }],
                    wedlock: [{required: true, message: '请输入婚姻状况', trigger: 'blur'}],
                    email: [{required: true, message: '请输入邮箱地址', trigger: 'blur'}, {
                        type: 'email',
                        message: '邮箱格式不正确',
                        trigger: 'blur'
                    }],
                    phone: [{required: true, message: '请输入电话号码', trigger: 'blur'}],
                },
                detailRules: {
                    name: [{required: true, message: '请输入职位名称', trigger: 'blur'}],
                    salary: [{required: true, message: '请输入薪资范围', trigger: 'blur'}],
                    jobNeedNum: [{required: true, message: '请输入招聘人数', trigger: 'blur'}, {pattern: /^\d{1,8}$/,
                        message: '只能输入纯数字'}],
                    sexNeed: [{required: true, message: '请选择性别要求', trigger: 'blur'}],
                }
            }
        },
        mounted() {
            this.initEmps();
            this.initData();
        },
        methods: {
            searvhViewHandleNodeClick(data) {
                this.inputDepName = data.name;
                this.searchValue.departmentId = data.id;
                this.popVisible2 = !this.popVisible2
            },
            rowKey(row){
                console.log( row.projectCode)
                row.projectCode;
            },
            handleSelectionChange (val) {
                console.log(val)
            },
            //1、使用插槽（推荐）
            getChangeType(e,z) {

                if('type' == z){
                    for (var i = 0; i < this.typeList.length; i++) {
                        if (this.typeList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.typeList[i].dictLabel;
                        }
                    }
                }else if('plat' == z){
                    for (var i = 0; i < this.platList.length; i++) {
                        if (this.platList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.platList[i].dictLabel;
                        }
                    }
                }else if('source' == z){
                    for (var i = 0; i < this.sourceList.length; i++) {
                        if (this.sourceList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.sourceList[i].dictLabel;
                        }
                    }
                }
               
            },

            onError(err, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
            },
            onSuccess(response, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
                this.initEmps();
            },
            beforeUpload() {
                this.importDataBtnText = '正在导入';
                this.importDataBtnIcon = 'el-icon-loading';
                this.importDataDisabled = true;
            },
            importData(){
                this.importDataDisabled = true;
            },
            exportData() {
                let a = this.$refs.projectTable.selection
                window.open('/employee/basic/export', '_parent');
            },
            exportTask() {
                let selected = this.$refs.projectTable.selection
                let arr = [];
                for(let temp in selected){
                    arr.push(selected[temp].projectCode)

                }
                window.open('/employee/basic/export', '_parent');
            },
            emptyEmp() {
                this.emp = {
                    name: "",
                    endContract: "",
                    workAge: null
                }
                this.inputDepName = '';
            },
            showEditEmpView(data) {
                // this.initPositions();
                this.title = '编辑信息';
                this.emp = data;
                // this.inputDepName = data.department.name;
                this.dialogVisible = true;
            },
            changeProvince(){
                this.cityList = [];
                this.selectedCity = null;
                if(this.provinceId != ''){
                    this.cityView =false; 
                }else{
                    this.cityView =true; 
                }
                this.cityLists.forEach((item) => {
                    if(this.provinceId === item.pid){
                        this.cityList = item.city;
                    }
                })
            },
            selectCity(value){
                let aa = this.emp.workCity;
                this.emp.workCity = value;
            },
            showAddIntershipView() {
                // this.initPositions();
                this.title = '新建信息';
                // this.inputDepName = data.department.name;
                this.dialogVisible = true;
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.jobName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/yl/internship/" + data.jobId).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            beTop(data) {
                data.beTop = !data.beTop;
                this.putRequest("/yl/internship/toTop",data).then(resp => {
                    if (resp) {
                        this.initEmps();
                    }
                })
            },
            doAddEmp() {
                if (this.emp.id) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/internship/updateInternship", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest('/yl/internship/addInternship', this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            handleNodeClick(data) {
                this.inputDepName = data.name;
                this.emp.departmentId = data.id;
                this.popVisible = !this.popVisible
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initPositions() {
                this.getRequest('/employee/basic/positions').then(resp => {
                    if (resp) {
                        this.positions = resp;
                    }
                })
            },
            showDetail(row){
                this.jobId = row.jobId;
                this.getRequest('/yl/internship/detail/getInternshipDetailList/'+row.jobId).then(resp => {
                    if (resp) {
                        this.details = resp.obj;
                    }
                })
                this.detailDisplay=true; 
            },
            showEditDetailView(data) {
                // this.initPositions();
                this.titleDetail = '编辑明细';
                this.detail = data;
                // this.inputDepName = data.department.name;
                this.showAddDetail = true;
            },
            openAddDetail(){
                this.titleDetail = '添加明细';
                this.detail={}
                // this.title = '新建信息';
                // this.inputDepName = data.department.name;
                this.showAddDetail = true;
            },
            addDetail(){
                this.detail.jobId = this.jobId;
                if (this.detail.id) {
                    this.$refs['detailForm'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/internship/detail/updateDetail", this.detail).then(resp => {
                                if (resp) {
                                    this.showAddDetail = false;
                                    this.initDetail();
                                    
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['detailForm'].validate(valid => {
                        if (valid) {
                            this.postRequest('/yl/internship/detail/addDetail', this.detail).then(resp => {
                                if (resp) {
                                    this.showAddDetail = false;
                                    this.initDetail();
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            deleteDetail(data) {
                this.$confirm('此操作将永久删除【' + data.name + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/yl/internship/detail/" + data.id).then(resp => {
                        if (resp) {
                            this.initDetail();
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            initDetail(){
                this.getRequest('/yl/internship/detail/getInternshipDetailList/'+ this.jobId).then(resp => {
                    if (resp) {
                        this.details = resp.obj;
                    }
                })
            },
            getMaxWordID() {
                this.getRequest("/employee/basic/maxWorkID").then(resp => {
                    if (resp) {
                        this.emp.workID = resp.obj;
                    }
                })
            },
            initData() {
                // if (!window.sessionStorage.getItem("nations")) {
                //     this.getRequest('/employee/basic/nations').then(resp => {
                //         if (resp) {
                //             this.nations = resp;
                //             window.sessionStorage.setItem("nations", JSON.stringify(resp));
                //         }
                //     })
                // } else {
                //     this.nations = JSON.parse(window.sessionStorage.getItem("nations"));
                // }
                // if (!window.sessionStorage.getItem("joblevels")) {
                //     this.getRequest('/employee/basic/joblevels').then(resp => {
                //         if (resp) {
                //             this.joblevels = resp;
                //             window.sessionStorage.setItem("joblevels", JSON.stringify(resp));
                //         }
                //     })
                // } else {
                //     this.joblevels = JSON.parse(window.sessionStorage.getItem("joblevels"));
                // }
                // if (!window.sessionStorage.getItem("politicsstatus")) {
                //     this.getRequest('/employee/basic/politicsstatus').then(resp => {
                //         if (resp) {
                //             this.politicsstatus = resp;
                //             window.sessionStorage.setItem("politicsstatus", JSON.stringify(resp));
                //         }
                //     })
                // } else {
                //     this.politicsstatus = JSON.parse(window.sessionStorage.getItem("politicsstatus"));
                // }
                // if (!window.sessionStorage.getItem("deps")) {
                //     this.getRequest('/employee/basic/deps').then(resp => {
                //         if (resp) {
                //             this.allDeps = resp;
                //             window.sessionStorage.setItem("deps", JSON.stringify(resp));
                //         }
                //     })
                // } else {
                //     this.allDeps = JSON.parse(window.sessionStorage.getItem("deps"));
                // }
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加项目';
                this.getMaxWordID();
                this.dialogVisible = true;
            },
            initEmps(type) {
                if (type && type == 'advanced') {
                    
                }
                this.loading = true;
                // let reqParam = {projectNameLike:this.keyword};
                this.searchValue['projectNameLike']=this.keyword
                this.searchValue['page']=this.page
                this.searchValue['limit']=this.size
                this.postRequest('/yl/internship/pc/getInternshipList', this.searchValue).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            },
           

        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }
    .companyTop{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .beTop{
        width: 31px;
        height: 17px;
        background: url("/static/img/top.png");
    }
    

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
